export default __webpack_public_path__ + "d2b0b9c0f61cdf313c370e25a949e708.png";